export default __webpack_public_path__ + "static/media/wcag-2.png.webp";